import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  PreviewContainer,
  PreviewWrapper,
  ActionButtonWrapper,
  CloseButton,
  ButtonContainer,
  DataWrap,
  Header,
} from './ResultsPreviewModal.style'
import Icon from 'components/Icon'
import ButtonCta from 'components/Button/ButtonCta'
import { PATRON_SCAN } from 'utils/constants'
import { useAccountCreation } from 'contexts/AccountCreation'

const ResultsPreviewModal = ({ retakePhoto, closePreviewModal, resultData }) => {
  const { patronScanUser, setPatronScanUser } = useAccountCreation()

  const dateOfBirth = moment.utc(resultData?.data?.dateOfBirth).format('YYYY/MM/DD')

  const fillTheFields = () => {
    const dataToFill = {
      firstName: resultData?.data?.firstName,
      lastName: resultData?.data?.lastName,
      postalCode: resultData?.data?.address?.postal,
      dob: dateOfBirth,
    }

    setPatronScanUser({ ...patronScanUser, ...dataToFill })
    closePreviewModal()
  }

  return (
    <PreviewContainer>
      <Header>{PATRON_SCAN.reviewResultHeading}</Header>
      <PreviewWrapper>
        {resultData?.data && (
          <>
            <DataWrap>
              <h2 className="keyName">{'First Name'}</h2> <h2 className="value">{resultData?.data?.firstName}</h2>
            </DataWrap>
            <DataWrap>
              <h2 className="keyName">{'Last Name'}</h2> <h2 className="value">{resultData?.data?.lastName}</h2>
            </DataWrap>
            <DataWrap>
              <h2 className="keyName">{'Postal Code'}</h2>{' '}
              <h2 className="value">{resultData?.data?.address?.postal}</h2>
            </DataWrap>
            <DataWrap>
              <h2 className="keyName">{'Date Of Birth'}</h2> <h2 className="value">{dateOfBirth}</h2>
            </DataWrap>
          </>
        )}
      </PreviewWrapper>

      <ActionButtonWrapper>
        <ButtonContainer>
          <ButtonCta type="button" theme="primary" onClick={retakePhoto} fullwidth>
            {PATRON_SCAN.retakeButtonText}
          </ButtonCta>
        </ButtonContainer>
        <ButtonContainer>
          <ButtonCta type="button" theme="primary" onClick={fillTheFields} fullwidth>
            {PATRON_SCAN.submit}
          </ButtonCta>
        </ButtonContainer>
      </ActionButtonWrapper>

      <CloseButton onClick={() => closePreviewModal()}>
        <Icon icon={'cross-orange'} customSize="80px" />
      </CloseButton>
    </PreviewContainer>
  )
}

ResultsPreviewModal.propTypes = {
  closePreviewModal: PropTypes.func,
  retakePhoto: PropTypes.func,
  resultData: PropTypes.object,
}

export default ResultsPreviewModal
